import { render, staticRenderFns } from "./retrievePassword.vue?vue&type=template&id=64f83c96&scoped=true&"
import script from "./retrievePassword.vue?vue&type=script&lang=js&"
export * from "./retrievePassword.vue?vue&type=script&lang=js&"
import style0 from "./retrievePassword.vue?vue&type=style&index=0&id=64f83c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f83c96",
  null
  
)

export default component.exports